import React from 'react';
import { connect } from 'react-redux';
import { setDesign, setDesignType, setSafetyFireAttack, setSafetyMinute } from '@reducers/selectors/design/actions';

import { Row, Col } from 'reactstrap';
import Accordion from '@components/Accordion';
import AccordionItem from '@components/Accordion/components/AccordionItem';

import FixedAnchorageDepth from '../../../Design/components/GeneralCalculationDesign/FixedAnchorageDepth';

import './styles.scss';
import { APP_TEXTS } from '../../../../texts/texts';
import { CalculationTypes as types } from '@reducers/selectors/design';
import { getDesignMethodName } from '../..';

const Method = props => (
  <Row>
    <Col sm="12">
      <div className="calculation method-tab">
        {/* {props.designStandard === standardList['EU'] && ( */}
          <section className="list-type">
            <label className={props.design === types.EN1992 ? '' : 'inactive'} htmlFor={types.EN1992}>
              <input
                id={types.EN1992} 
                type="radio"
                name="calculationUsed" // use the same name for radio buttons
                onChange={(e) => {
                  props.setDesign(e.target.id);
                  if (props.designType !== types.EN1992_TYPE_ONE && props.designType !== types.EN1992_TYPE_TWO)
                    props.setDesignType(types.EN1992_TYPE_ONE);
                }}
                checked={props.design === types.EN1992}
              />
              <b>&nbsp;{getDesignMethodName(props.designStandard)}</b>
            </label>
            {/* {props.design === types.EN1992 && (
              <div className="ml-3">
              <label htmlFor={types.EN1992_TYPE_ONE} className="radio-group__item">
                <input
                id={types.EN1992_TYPE_ONE}
                type="radio"
                name="etagType"
                onChange={(e) => {
                  props.setDesign(types.EN1992);
                  props.setDesignType(e.target.id);
                }}
                defaultChecked={props.designType === types.EN1992_TYPE_ONE}
                />
                {APP_TEXTS.METHOD_POST_INSTALLED_MECHANICAL_FASTENERS.Content}
                </label>
              <label htmlFor={types.EN1992_TYPE_TWO} className="radio-group__item">
                <input
                  id={types.EN1992_TYPE_TWO}
                  type="radio"
                  name="etagType"
                  onChange={(e) => {
                    props.setDesign(types.EN1992);
                    props.setDesignType(e.target.id);
                  }}
                  defaultChecked={props.designType === types.EN1992_TYPE_TWO}
                />
                {APP_TEXTS.METHOD_POST_INSTALLED_BONDED_FASTENERS.Content}
              </label>
            </div>
            )} */}
         </section>
        {/* )} */}
        {/* {props.designStandard !== standardList['EU'] && (
          <section className="list-type">
            <label className={props.design === types.ETAG ? '' : 'inactive'} htmlFor={types.ETAG}>
              <input
                id={types.ETAG}
                type="radio"
                name="calculationUsed" // use the same name for radio buttons
                onChange={(e) => props.setDesign(e.target.id)}
                defaultChecked={props.design === types.ETAG}
              />
              <b>&nbsp;<span className="text-uppercase">{APP_TEXTS.METHOD_ETAG.Content}</span>{APP_TEXTS.METHOD_CALCULATION.Content}</b>
            </label>
            <span>{APP_TEXTS.METHOD_A_DESIGN_RESISTANCE.Content}</span>
            <span>{APP_TEXTS.METHOD_ANNEX_C_ETA_GUIDANCE001.Content}</span>
            {props.design === types.ETAG && (
              <div className="ml-3">
                <label htmlFor={types.ETAG_TYPE_ONE} className="radio-group__item">
                  <input
                    id={types.ETAG_TYPE_ONE}
                    type="radio"
                    name="etagType"
                    onChange={(e) => props.setDesignType(e.target.id)}
                    defaultChecked={props.designType === types.ETAG_TYPE_ONE}
                  />
                  {APP_TEXTS.METHOD_ULTIMATE_LIMIT.Content}
                </label>
                <label htmlFor={types.ETAG_TYPE_TWO} className="radio-group__item">
                  <input
                    id={types.ETAG_TYPE_TWO}
                    type="radio"
                    name="etagType"
                    onChange={(e) => props.setDesignType(e.target.id)}
                    defaultChecked={props.designType === types.ETAG_TYPE_TWO}
                  />
                {APP_TEXTS.METHOD_VARIABLE_ANCHORAGE_ADHESIVE_ANCHORS.Content} <br/>
                  {APP_TEXTS.METHOD_CASE_NO_VALUE.Content}
                </label>
              </div>
            )}
          </section>
        )} */}

        {/* {props.designStandard !== standardList['EU'] && (
          <section className="list-type">
            <label className={props.design === types.CEN ? '' : 'inactive'} htmlFor={types.CEN}>
              <input
                id={types.CEN}
                type="radio"
                name="calculationUsed" // use the same name for radio buttons
                onChange={(e) => props.setDesign(e.target.id)}
                defaultChecked={props.design === types.CEN}
              />
              <b>&nbsp;<span className="text-uppercase">cen/ts</span>{APP_TEXTS.METHOD_CALCULATION.Content}</b>
            </label>
            <span>{APP_TEXTS.DEISGN_RESISTANCE_ULTIMATE_STATE.Content}
              <span className="text-uppercase">cen/ts</span>
            </span>
            <span>{APP_TEXTS.DESIGN_RESISTANCE_ULTIMATE_STATE_ACCORDING_TO.Content}</span>
            {props.design === types.CEN &&
            <div className="ml-3">
              <label htmlFor={props.CEN_TYPE_ONE} className="radio-group__item">
                <input
                  id={props.CEN_TYPE_ONE}
                  type="radio"
                  name="cenType"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.CEN_TYPE_ONE}
                />
                {APP_TEXTS.METHOD_MECHANICAL_AND_ADHESIVE_ANCHORS.Content}
              </label>
              <label htmlFor={types.CEN_TYPE_TWO} className="radio-group__item">
                <input
                  id={types.CEN_TYPE_TWO}
                  type="radio"
                  name="cenType"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.CEN_TYPE_TWO}
                />
               {APP_TEXTS.METHOD_CHEMICAL_ANCHORS.Content} <br/>
                {APP_TEXTS.METHOD_CASE_NO_VALUE.Content}
              </label>
            </div>
            }
          </section>
        )} */}

        {/* <section className="list-type">
          <label className={props.design === types.FIRE ? '' : 'inactive'} htmlFor={types.FIRE}>
            <input
              id={types.FIRE}
              type="radio"
              name="calculationUsed" // use the same name for radio buttons
              onChange={(e) => props.setDesign(e.target.id)}
              defaultChecked={props.design === types.FIRE}
            />
            <b>
              &nbsp;
              <span className="text-uppercase">{APP_TEXTS.DESIGN_METHOD_FIRE.Content}</span>
              {APP_TEXTS.METHOD_CALCULATION.Content}
            </b>
          </label>
          <span>{APP_TEXTS.METHOD_FIRE_EXPOSURE.Content}</span>
          
          {props.design === types.FIRE && (
            <React.Fragment>
              <label htmlFor="minute">
                <select
                  onChange={e => props.setSafetyMinute(e.target.value)}
                  id="minute"
                  name="minute"
                  className="form-control w-25 mr-2"
                >
                  <option value="30">30</option>
                </select>
                {APP_TEXTS.DESIGN_REBAR_MINUTE.Content}
              </label>

              <label htmlFor="fire_attay">
                <select
                  onChange={e => props.setSafetyFireAttack(e.target.value)}
                  id="fire_attay"
                  name="fire_attay"
                  className="form-control w-25 mr-2"
                >
                  <option value="one_side">{APP_TEXTS.SAFETY_BARRIER_ONE_SIDE.Content}</option>
                </select>
                {APP_TEXTS.SAFETY_BARRIER_FIRE_ATTACK.Content}
              </label>
          </React.Fragment>
          )}
        </section>

        <section className="list-type">
          <label className={props.design === types.SEISMIC ? '' : 'inactive'} htmlFor={types.SEISMIC}>
            <input
              id={types.SEISMIC}
              type="radio"
              name="calculationUsed" // use the same name for radio buttons
              onChange={(e) => props.setDesign(e.target.id)}
              defaultChecked={props.design === types.SEISMIC}
            />
            <b>&nbsp;{APP_TEXTS.METHOD_SEISMIC_CALCULATION.Content}</b>
          </label>
          <span>{APP_TEXTS.METHOD_SEISMIC_CALCULATION_DESCRIPTION.Content}</span>
        </section> */}
      </div>
      
      <Accordion className="application__accordion" appStatus={props.appStatus}>
        <AccordionItem id="fixed_anchorage_depth" title={APP_TEXTS.ANCHOR_DEPTH_TITLE.Content}>
          <FixedAnchorageDepth />
        </AccordionItem>
      </Accordion>

    </Col>
  </Row>
);

const mapState = state => ({
  designStandard: Number(state.main.localization.designStandard),
  design: state.selectors.design[state.main.appType].design,
  designType: state.selectors.design[state.main.appType].designType,
  appStatus: state.main.status // use it as a hack to render a potential language change
});

const mapDispatch = {
  setDesign,
  setDesignType,
  setSafetyMinute,
  setSafetyFireAttack
};

export default connect(mapState, mapDispatch)(Method);



// WEBPACK FOOTER //
// ./src/views/Design/components/Method/index.js